import { useMemo } from 'react'

export function useServiceBreakdown(raw: { service: string; cost: number; percentage: number }[]) {
  // sort descending by cost
  const sorted = useMemo(() => [...raw].sort((a, b) => b.cost - a.cost), [raw])

  const top10 = sorted.slice(0, 10)
  const rest = sorted.slice(10)

  return { top10, rest, sorted }
}
